var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderLine = function SvgFolderLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.3 5.7v12.6h14.4V7.5h-7.573l-1.8-1.8zm7.573 0H20.6a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h6.673z"
  })));
};
export default SvgFolderLine;